<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 200 200" enable-background="new 0 0 200 200" xml:space="preserve">
  <g>
    <path fill="none" d="M115,51.591c0-2.64-2.207-4.591-4.847-4.591H91.032C88.392,47,86,48.951,86,51.591V56h29V51.591z"/>
    <path fill="none" d="M81.471,66H67v71.639C67,145.559,73.551,152,81.471,152h38.244c7.92,0,14.285-6.441,14.285-14.361V66h-14.285
      H81.471z M96,128.077c0,2.641-2.36,4.78-5,4.78s-5-2.14-5-4.78V94.615c0-2.641,2.36-4.781,5-4.781s5,2.141,5,4.781V128.077z
      M115,128.077c0,2.641-2.359,4.78-5,4.78s-5-2.14-5-4.78V94.615c0-2.641,2.359-4.781,5-4.781s5,2.141,5,4.781V128.077z"/>
    <path class="color" fill="#F45B5B" d="M148.396,56H124v-4.409C124,43.671,118.074,37,110.153,37H91.032C83.111,37,77,43.671,77,51.591V56H52.789
      c-2.64,0-4.78,2.36-4.78,5s2.14,5,4.78,5H58v71.639C58,150.839,68.271,162,81.471,162h38.244c13.2,0,24.285-11.161,24.285-24.361
      V66h4.396c2.641,0,4.78-2.36,4.78-5S151.037,56,148.396,56z M86,51.591C86,48.951,88.392,47,91.032,47h19.122
      c2.64,0,4.847,1.951,4.847,4.591V56H86V51.591z M134,137.639c0,7.92-6.365,14.361-14.285,14.361H81.471
      C73.551,152,67,145.559,67,137.639V66h14.471h38.244H134V137.639z"/>
    <path class="color" fill="#F45B5B" d="M91,89.834c-2.64,0-5,2.141-5,4.781v33.462c0,2.641,2.36,4.78,5,4.78s5-2.14,5-4.78V94.615
      C96,91.975,93.64,89.834,91,89.834z"/>
    <path class="color" fill="#F45B5B" d="M110,89.834c-2.641,0-5,2.141-5,4.781v33.462c0,2.641,2.359,4.78,5,4.78s5-2.14,5-4.78V94.615
      C115,91.975,112.641,89.834,110,89.834z"/>
  </g>
  </svg>
</template>

<script>
export default {
  name: 'TrashIcon'
}
</script>
